import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PublicAppInfo } from '@oca/web-shared';

@Injectable({ providedIn: 'root' })
export class AppService {
  private http = inject(HttpClient);

  getAppInfo(urlName: string) {
    return this.http.get<PublicAppInfo>(`/api/web/app/name/${urlName}`);
  }
}
